/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter two valid hex colours to see the contrast ratio.`)
};

const es_cc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce dos colores hexadecimales válidos para ver el ratio de contraste.`)
};

const de_cc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib zwei gültige Hex-Farben ein, um das Kontrastverhältnis zu sehen.`)
};

const nl_cc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul twee geldige hexkleuren in om de contrastverhouding te zien.`)
};

const fr_cc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez deux couleurs hexadécimales valides pour voir le ratio de contraste.`)
};

const it_cc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci due colori esadecimali validi per vedere il rapporto di contrasto.`)
};

const pt_br2_cc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe duas cores hex válidas para ver a taxa de contraste.`)
};

const pt_cc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza duas cores hex válidas para ver o rácio de contraste.`)
};

const ja_cc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コントラスト比を見るには、有効な16進数カラーを2つ入力してください。`)
};

const zh_cc_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入两个有效的十六进制颜色以查看对比度。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_hint", locale)
	if (locale === "en") return en_cc_hint(inputs)
	if (locale === "es") return es_cc_hint(inputs)
	if (locale === "de") return de_cc_hint(inputs)
	if (locale === "nl") return nl_cc_hint(inputs)
	if (locale === "fr") return fr_cc_hint(inputs)
	if (locale === "it") return it_cc_hint(inputs)
	if (locale === "pt-BR") return pt_br2_cc_hint(inputs)
	if (locale === "pt") return pt_cc_hint(inputs)
	if (locale === "ja") return ja_cc_hint(inputs)
	return zh_cc_hint(inputs)
};